import * as React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from 'helpers/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  submit: {
    width: '100%',
    height: 44,
    margin: [20, 0, 0, 0],
    fontSize: 14,
    color: theme.colors.primaryWhite,
    background: '#0b57ff',
    border: '1px solid rgba(255, 255, 255, 0.18)',
    boxShadow:
      '0 1px 2px rgba(11, 87, 255, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.12)',
    borderRadius: theme.primaryBorderRadius,
    cursor: 'pointer',
    transition: 'background-color 0.15s',
    '&:hover': {
      backgroundColor: '#0a4cdf'
    },
    '&::-moz-focus-inner': {
      border: 0
    }
  }
}));

type Props = {
  text: string;
};

function FancyButton({
  text,
  ...props
}: Props & React.PropsWithoutRef<JSX.IntrinsicElements['input']>) {
  const classes = useStyles();

  return (
    <input {...props} type="submit" value={text} className={classes.submit} />
  );
}

export default FancyButton;
